var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_631_1629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.993 0H0.00703125C0.003148 0 0 0.003148 0 0.00703125V23.993C0 23.9969 0.003148 24 0.00703125 24H23.993C23.9969 24 24 23.9969 24 23.993V0.00703125C24 0.003148 23.9969 0 23.993 0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 17.3438C15.6562 18.1406 16.3125 18.7031 17.3906 18.7031C18.3281 18.7031 18.9375 18.2344 18.9375 17.5781C18.9375 16.8281 18.3281 16.5469 17.2969 16.0781L16.7344 15.8438C15.0938 15.1406 14.0156 14.2969 14.0156 12.4688C14.0156 10.7812 15.2812 9.46875 17.2969 9.46875C18.75 9.46875 19.7812 9.98438 20.4844 11.2969L18.75 12.4219C18.375 11.7188 17.9531 11.4375 17.2969 11.4375C16.6406 11.4375 16.2188 11.8594 16.2188 12.4219C16.2188 13.0781 16.6406 13.3594 17.625 13.7812L18.1875 14.0156C20.1094 14.8594 21.1875 15.6562 21.1875 17.5781C21.1875 19.5938 19.5938 20.7188 17.4375 20.7188C15.3281 20.7188 13.9688 19.7344 13.3125 18.4219L15.1875 17.3438ZM7.21875 17.5312C7.59375 18.1406 7.875 18.7031 8.67188 18.7031C9.42188 18.7031 9.89062 18.4219 9.89062 17.2969V9.51562H12.1406V17.2031C12.1406 19.5469 10.7812 20.5781 8.76562 20.5781C6.9375 20.5781 5.90625 19.6406 5.39062 18.5156L7.21875 17.5312Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_631_1629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJavascript);
export default __webpack_public_path__ + "static/media/icon-javascript.de38b81666d8436d49be0930ccd61f39.svg";
export { ForwardRef as ReactComponent };